// See docs/ai/websocket-events.md → "Originator filter".
let connectionId: string | null = null;

export const getWsConnectionId = () => connectionId;
export const setWsConnectionId = (value: string | null) => {
  connectionId = value;
};
